import kerela1 from '../../Images/FeaturedDestination/kerela/kerela1.jpg';
import kerela2 from '../../Images/FeaturedDestination/kerela/kerela2.jpg';
import kerela3 from '../../Images/FeaturedDestination/kerela/kerela3.jpg';
import goa1 from '../../Images/FeaturedDestination/Goa/goa1.jpg';
import goa2 from '../../Images/FeaturedDestination/Goa/goa2.jpg';
import goa3 from '../../Images/FeaturedDestination/Goa/goa3.jpg';
import ladakh1 from '../../Images/FeaturedDestination/Ladakh/ladakh1.jpg';
import ladakh2 from '../../Images/FeaturedDestination/Ladakh/ladakh2.jpg';
import ladakh3 from '../../Images/FeaturedDestination/Ladakh/ladakh3.jpg';
import andaman1 from '../../Images/FeaturedDestination/Andaman/andaman1.jpg';
import andaman2 from '../../Images/FeaturedDestination/Andaman/andaman2.jpg';
import andaman3 from '../../Images/FeaturedDestination/Andaman/andaman3.jpg';
import sikkim1 from '../../Images/FeaturedDestination/Sikkim/sikkim1.jpg';
import sikkim2 from '../../Images/FeaturedDestination/Sikkim/sikkim2.jpg';
import sikkim3 from '../../Images/FeaturedDestination/Sikkim/sikkim3.jpg';
import kashmir1 from '../../Images/FeaturedDestination/Kashmir/kashmir1.jpg';
import kashmir2 from '../../Images/FeaturedDestination/Kashmir/kashmir2.jpg';
import kashmir3 from '../../Images/FeaturedDestination/Kashmir/kashmir3.jpg';
import Raj1 from '../../Images/Domestic/Rajasthan/Raj1.jpg';
import Raj2 from '../../Images/Domestic/Rajasthan/Raj2.jpg';
import Raj3 from '../../Images/Domestic/Rajasthan/Raj3.jpg';
import RajWild1 from '../../Images/Domestic/Rajasthan/RajWild1.jpg';
import RajWild2 from '../../Images/Domestic/Rajasthan/RajWild2.jpg';
import RajWild3 from '../../Images/Domestic/Rajasthan/RajWild3.jpg';
import MagRaj1 from '../../Images/Domestic/Rajasthan/MagRaj1.jpg';
import MagRaj2 from '../../Images/Domestic/Rajasthan/MagRaj2.jpg';
import MagRaj3 from '../../Images/Domestic/Rajasthan/MagRaj3.jpg';
import GoldRaj1 from '../../Images/Domestic/Rajasthan/GoldRaj1.jpg';
import GoldRaj2 from '../../Images/Domestic/Rajasthan/GoldRaj2.jpg';
import GoldRaj3 from '../../Images/Domestic/Rajasthan/GoldRaj3.jpg';
import Rajas1 from '../../Images/Domestic/Rajasthan/Rajas1.jpg';
import Rajas2 from '../../Images/Domestic/Rajasthan/Rajas2.jpg';
import Rajas3 from '../../Images/Domestic/Rajasthan/Rajas3.jpg';
import RoyalRaj1 from '../../Images/Domestic/Rajasthan/RoyalRaj1.jpg';
import RoyalRaj2 from '../../Images/Domestic/Rajasthan/RoyalRaj2.jpg';
import RoyalRaj3 from '../../Images/Domestic/Rajasthan/RoyalRaj3.jpg';
import and1 from '../../Images/Domestic/Rajasthan/and1.jpg';
import and2 from '../../Images/Domestic/Rajasthan/and2.jpg';
import and3 from '../../Images/Domestic/Rajasthan/and3.jpg';
import nico1 from '../../Images/Domestic/Rajasthan/nico1.jpg';
import nico2 from '../../Images/Domestic/Rajasthan/nico2.jpg';
import nico3 from '../../Images/Domestic/Rajasthan/nico3.jpg';
import rajasthan1 from '../../Images/FeaturedDestination/Rajasthan/rajasthan1.jpg';
import rajasthan2 from '../../Images/FeaturedDestination/Rajasthan/rajasthan2.jpg';
import rajasthan3 from '../../Images/FeaturedDestination/Rajasthan/rajasthan3.jpg';

const locations = [
  {
    id: "DelhiAgraJaipur",
    title: "Delhi-Agra-Jaipur-Delhi",
    description: "5-day cultural odyssey across Delhi , Agra , Jaipur. Experience the rich heritage and vibrant culture of North India.",
    images: [Raj1,Raj2,Raj3],
    region: "North India",
    tripDuration: "04 Nights/ 05 Days",
    Startpoint: "Delhi",
    Endpoint: "Delhi",
    features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"]
  },
  {
    id: "Goa",
    title: "Goa",
    description: "A tropical paradise known for its golden beaches, vibrant nightlife, Portuguese heritage, and laid-back coastal charm.",
    images: [RajWild1,RajWild2,RajWild3],
    region: "North India",
    tripDuration: "06 Nights / 07 Days",
    Startpoint: " Goa",
    Endpoint: " Goa",
    features: ["Accommodation", "Safari", "Transport", "Meals", "Guides"]
  },
  {
    id: "JaipurJodhpurJaisalmerBikaner",
    title: "Jaipur-Jodhpur-Jaisalmer-Bikaner-Jaipur",
    description: "Classic 7-day tour covering Jaipur , Jodhpur , Jaisalmer , Bikaner , Jaipur. A perfect blend of culture and heritage.",
    images: [GoldRaj1,GoldRaj2,GoldRaj3],
    region: "   North India",
    tripDuration: "06 Nights/07 Days",
    Startpoint: "Jaipur",
    Endpoint: "Jaipur",
    features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
  },
  {
    id: "JaipurAjmerPushkarJodhpurUdaipur",
    title: "Jaipur-Ajmer-Pushkar-Jodhpur-Udaipur",
    description: "7-day exploration of Jaipur , Ajmer , Pushkar , Jodhpur , Udaipur. Palaces, lakes, and vibrant bazaars await.",
    images: [MagRaj1,MagRaj2,MagRaj3], 
    region: "North India",
    tripDuration: "06Nights / 07 Days",
    Startpoint: "Jaipur",
    Endpoint: "Udaipur",
    features: ["Accommodation", "Guides", "Transport", "Cultural Events"]
  },
  {
    id: "Kerala",
    title: "Kerala",
    description: "Known for its lush greenery, tranquil backwaters, pristine beaches, rich culture, and high literacy rate",
    images: [rajasthan1, rajasthan2, rajasthan3],
    region: "North India",
    tripDuration: " 06 Nights/07 Days",
    Startpoint: " Cochin",
    Endpoint: "Alleppey",
    features: ["Accommodation", "Transport", "Activities", "Meals"]
  },
  {
    id: "LehLadakh",
    title: "leh ladakh",
    description: "India’s union territory of Ladakh, is a land of surreal beauty, nestled between the Karakoram and Himalayan mountain ranges",
    images: [Rajas1,Rajas2,Rajas3],
    region: "leh-Ladakh",
    tripDuration: "06 Nights / 07 Days",
    Startpoint: "leh-ladakh",
    Endpoint: "leh-ladakh",
    features: ["Accommodation", "Romantic Dinner", "Sightseeing", "Transport"]
  },
  {
    id: "Kashmir",
    title: "love in Kashmir",
    description: "Kashmir, often called “Paradise on Earth,” is a stunning region nestled in the northernmost part of India in the Jammu & Kashmir union territory. ",
    images: [RoyalRaj1,RoyalRaj2,RoyalRaj3],
    region: "North India",
    tripDuration: "08 Nights / 09 Days",
    Startpoint: "Srinagar",
    Endpoint: " Gulmarg",
    features: ["Accommodation", "Camel Safari", "Transport", "Meals"]
  },
  {
    id: "Nainital",
    title: "Nainital",
    description: "9 Days tour covering Delhi-Nainital-Kausani-Corbett . Nainital is a charming hill station nestled in the Kumaon region of Uttarakhand, India.",
    images: [MagRaj1, rajasthan2, GoldRaj1],
    region: "North India",
    tripDuration: " 08 Nights/ 09 Days",
    Startpoint: " Delhi",
    Endpoint: " Delhi",
    features: ["Accommodation", "Temple Visits", "Guides", "Transport"]
  },
  {  
    id: "Udaipur",
    title: "Romantic Udaipur",
    description: "5 Days tour covering Kumbhalgarh , Ranakpur , Chittorgarh , Nathdwara , Eklingjee ,Haldighati.",
    images: [and1, and2, and3],
    region: "North India",
    tripDuration: " 04 Nights / 05 Days",
    Startpoint: "Udaipur",
    Endpoint: "Haldighati",
    features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"]
  },
  {  
    id: "ShimlaManali",
    title: "Shimla Manali Tour",
    description: "two scenic hill stations known for their natural beauty, colonial charm, adventure sports, and snowy landscapes.",
    images: [nico1, nico2, nico3],
    region: "North India",
    tripDuration: " 06 Nights/07 Days",
    Startpoint: " Delhi",
    Endpoint: "Manali",
    features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"]
  },
 
  
];

export default locations;